import React, { ReactNode } from 'react';

const buildsEnhancedMarkdownOverrides = {
  p: ParagraphThatIsHiddenOnCompact,
};

function ParagraphThatIsHiddenOnCompact({ children }: { children: ReactNode }) {
  return <p className={'hide-on-compact'}>{children}</p>;
}

export default buildsEnhancedMarkdownOverrides;
